import SortingGate, { GetAllCalculatorKeys } from "../../../calculators/calculatorLookupTable";
import { ThemeContext, speedwayThemes } from "Clutch/Contexts/ThemeContext";

export async function getStaticPaths() {
  const allCalcKeys = GetAllCalculatorKeys();

  const paths = allCalcKeys.map(x => {
    return {
      params: {
        calckey: x
      }
    }
  })

  return {
    paths,
    fallback: "blocking"
  }
}

export async function getStaticProps({ params }) {
  return {
    props: params,
    revalidate: 604800
  };
}


export default function Calculator({ pageProps, calckey }) {

  return <ThemeContext.Provider
    value={speedwayThemes["Light"]}
  >
    <SortingGate calckey={pageProps?.calckey ?? calckey} />
  </ThemeContext.Provider>;
}